import { LitElement, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { html, literal, type StaticValue } from 'lit/static-html.js';
import { DevicePointerType, devicePointerType } from '../../base/package/util/device';
import './internal/ui-carousel-css';
import componentStyle from './ui-custom-carousel.css?inline';

const CName = 'ui-custom-carousel';

/**
 * @param {string} padding - This padding will be applied to the start and end of the carousel.
 */
@customElement(CName)
export class UICarousel extends LitElement {
  static readonly styles = unsafeCSS(componentStyle);

  @property({ type: String }) padding = '0';

  private _tag: StaticValue =
    devicePointerType() === DevicePointerType.TOUCH ? literal`ui-carousel-css` : literal`ui-carousel-js`;

  connectedCallback() {
    super.connectedCallback();
    if (window.$app.appConfig.prerenderMode) {
      // Use CSS only carousel in prerender mode as there will not be any JavaScript available in static page.
      this._tag = literal`ui-carousel-css`;
    } else if (devicePointerType() !== DevicePointerType.TOUCH) {
      import('./internal/ui-carousel-js');
    }
  }

  /* eslint-disable lit/binding-positions, lit/no-invalid-html */
  render() {
    return html`
      <${this._tag} padding=${this.padding}><slot></slot></${this._tag}>
    `;
  }
  /* eslint-enable lit/binding-positions, lit/no-invalid-html */
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UICarousel;
  }
}
